<template>
  <div class="admin-shell">
    <div class="sidebar-overlay" v-if="sidebarOpen" @click="sidebarOpen = false"></div>
    <SidebarNav
      :isOpen="sidebarOpen"
      :adminName="authStore.adminName"
      :role="authStore.role"
      :canManageAdmins="authStore.canManageAdmins"
      :canManageRepasses="authStore.canManageRepasses"
      :canSeeSaques="authStore.canSeeFinanceiro"
      :canShowCheckin="authStore.canShowCheckin"
      @logout="handleLogout"
    />
    <main class="admin-main">
      <header class="mobile-header">
        <button class="hamburger" @click="sidebarOpen = !sidebarOpen" aria-label="Menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <span class="mobile-title">Inscrições</span>
      </header>
      <div class="content">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import SidebarNav from '../components/ui/SidebarNav.vue'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'AdminLayout',
  components: { SidebarNav },
  data() { return { sidebarOpen: false } },
  computed: {
    authStore() { return useAuthStore() }
  },
  watch: {
    '$route'() { this.sidebarOpen = false }
  },
  mounted() {
    this.authStore.refresh()
    this.prepararPwa()
  },
  methods: {
    /**
     * Manifest e service worker so aqui, nunca no index.html: o mesmo app serve
     * as paginas publicas de evento, e um manifest global faria um inscrito que
     * adicionasse a pagina do ACAMP a tela de inicio ganhar um atalho que abre
     * no painel.
     */
    prepararPwa() {
      if (!document.querySelector('link[rel="manifest"]')) {
        const link = document.createElement('link')
        link.rel = 'manifest'
        link.href = '/manifest-admin.json'
        document.head.appendChild(link)
      }
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {})
      }
    },
    handleLogout() {
      this.authStore.logout()
      this.$router.push('/admin/login')
    }
  }
}
</script>

<style scoped>
.admin-shell { display: flex; min-height: 100vh; min-height: 100svh; }
.admin-main {
  flex: 1;
  margin-left: 240px;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.content {
  flex: 1;
  padding: clamp(16px, 3vw, 32px);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.mobile-header {
  display: none;
  align-items: center;
  gap: var(--spacing-md);
  padding: 12px 16px;
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-card);
  position: sticky;
  top: 0;
  z-index: 40;
}
.hamburger {
  background: none; border: none; cursor: pointer;
  color: var(--color-text-primary);
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  margin-left: -8px;
}
.mobile-title { font-size: var(--text-md); font-weight: 700; }
.sidebar-overlay {
  display: none;
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 45;
}
@media (max-width: 900px) {
  .admin-main { margin-left: 0; }
  .mobile-header { display: flex; }
  .sidebar-overlay { display: block; }
}
</style>
